function translateToken(char: string, token: string, afterHour: boolean): string {
  switch (char) {
    case 'Y':
      return 'y'.repeat(token.length);
    case 'D':
      return 'd'.repeat(token.length);
    case 'M':
      return afterHour ? 'm'.repeat(token.length) : token;
    case 'S':
      return afterHour ? 's'.repeat(token.length) : token;
    default:
      return token;
  }
}

export function toDateFnsPattern(pattern: string): string {
  let result = '';
  let insideLiteral = false;
  let afterHour = false;
  let index = 0;

  while (index < pattern.length) {
    const char = pattern[index];

    if (char === "'") {
      insideLiteral = !insideLiteral;
      result += char;
      index += 1;
      continue;
    }

    let length = 1;
    while (pattern[index + length] === char) {
      length += 1;
    }
    const token = pattern.slice(index, index + length);
    index += length;

    if (insideLiteral) {
      result += token;
      continue;
    }

    if (char === 'H' || char === 'h') {
      afterHour = true;
    } else if (char === 'Y' || char === 'y' || char === 'D' || char === 'd') {
      afterHour = false;
    }

    result += translateToken(char, token, afterHour);
  }

  return result;
}
